// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/header/header.component.scss
// module id = 346
// module chunks = 0